import { goBack } from 'assets/icons';
import { Row, Col, Card, Typography, Tabs } from 'antd';
import React, { useState } from 'react'
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useLoadTaxInvoiceData } from 'hooks/useOrders';
import { useAppSelector } from 'store';
import TableInvoiceRequestTable from './TaxInvoiceRequestTable';

const ManageTaxInvoiceRequest = () => {
    const navigate = useNavigate();

    const [searchInput, setSearchInput] = useState<string>('');
    const [dateStartInput, setDateStartInput] = useState<string>('');
    const [dateEndInput, setDateEndInput] = useState<string>('');

    const [limit, setLimit] = useState<number>(10);
    const [offset, setOffset] = useState<number>(0);

    const handleSetOffset = (value: number) => {
      setOffset(value || 0);
    };
  
    const handleSetLimit = (value: number) => {
      setLimit(value || 10);
    };
  
    const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
    const { data: taxListData } = useLoadTaxInvoiceData({
      search: searchInput,
      factory_id: factoryId ?? '',
      is_active: true,
      start_date: dateStartInput,
      end_date: dateEndInput,
      offset: offset,
      limit: limit
    });
    
    const items = [
      {
        label: `ใบกำกับภาษี`,
        key: "0",
        children: 
        <>
          <TableInvoiceRequestTable 
            data={taxListData?.data}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            dateStartInput={dateStartInput}
            setDateStartInput={setDateStartInput}
            dateEndInput={dateEndInput}
            setDateEndInput={setDateEndInput}
            limit={limit}
            handleSetOffset={handleSetOffset}
            handleSetLimit={handleSetLimit}
           />
        </>
        ,
      }
    ];
  return (
  <>
    <Card bordered={false} className="criclebox h-full tabs-mobile">
      <HeaderTabs>
        <IconWrapper
          onClick={() => {
            navigate("/setting");
          }}
        >
          <SpanIcon>{goBack}</SpanIcon>
        </IconWrapper>
        <Typography.Title level={5}>ใบกำกับภาษี</Typography.Title>
        <RightIconWrapper></RightIconWrapper>
      </HeaderTabs>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col sm={24} md={24}>
          <Tabs
            defaultActiveKey={'0'}
            style={{ height: "100%" }}
            items={items}
            key="key"
          />
        </Col>
      </Row>
    </Card>
  </>
  )
}

export default ManageTaxInvoiceRequest

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
